export default function CookieDefs() {
    return {
        ACCESS_TOKEN: "access_token",
        USER_ID: "userId",
        USER_NAME: "name",
        USER_USERNAME: "username",
        USER_URI_AVATAR: "urlAvatar",
    };
};